import { ReactElement } from 'react';
import { useDispatch } from 'react-redux';

import { resetPaymentMethod } from '@cashier/cashier-data-access';
import { RedirectContainers, ResultAction } from '@cashier/cashier-model';

import { HiddenFormProvider } from '../contexts';
import { HiddenForm } from '../modules/hiddenForm';
import { PaymentProgress } from '../modules/paymentProgress/v1';
import { ProviderIframe } from '../modules/providerIframe';
import { PaymentProcessingConfigurator } from '../utils/paymentProcessingConfiguration';

interface PaymentProcessingProps {
  loadingPageUrl: string;
  resultAction: ResultAction;
  paymentMethod: {
    name: string;
    redirectContainer: RedirectContainers;
  };
  isWebView?: boolean;
}

export const PaymentProcessing = ({
  loadingPageUrl,
  resultAction,
  paymentMethod,
  isWebView = false,
}: PaymentProcessingProps): ReactElement => {
  const dispatch = useDispatch();

  const { hiddenForm, providerIframe, paymentProgress } =
    PaymentProcessingConfigurator.configure({
      resultAction,
      paymentMethod,
      loadingPageUrl,
    });

  return (
    <HiddenFormProvider>
      {hiddenForm && <HiddenForm {...hiddenForm} />}

      {providerIframe && (
        <ProviderIframe {...providerIframe} defaultSize={600} />
      )}

      {!providerIframe && (
        <PaymentProgress
          {...paymentProgress}
          isWebView={isWebView}
          loadingPageUrl={loadingPageUrl}
          paymentMethodName={paymentMethod.name}
          handlePaymentCancelled={() => dispatch(resetPaymentMethod())}
        />
      )}
    </HiddenFormProvider>
  );
};
